import { defineMessages } from 'react-intl';

export const scope = 'app.components.Checkout.Voucher';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Kamereo Voucher',
  },
  apply: {
    id: `${scope}.apply`,
    defaultMessage: 'Áp dụng',
  },
  applied: {
    id: `${scope}.applied`,
    defaultMessage: 'Đã áp dụng',
  },
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Nhập mã giảm giá',
  },
  clear: {
    id: `${scope}.clear`,
    defaultMessage: 'Xóa mã giảm giá {code}',
  },
  invalid: {
    id: `${scope}.invalid`,
    defaultMessage: 'Không đủ điều kiện',
  },
  expired: {
    id: `${scope}.expired`,
    defaultMessage: 'Mã giảm giá {code} đã hết hạn',
  },
  notSatisfied: {
    id: `${scope}.notSatisfied`,
    defaultMessage: 'Mã giảm giá {code} chỉ sử dụng cho đơn hàng có tổng trị giá trên {total}',
  },
  expiredAt: {
    id: `${scope}.expireAt`,
    defaultMessage: 'HSD',
  },
  voucherDetail: {
    id: `${scope}.voucherDetail`,
    defaultMessage: 'Tối đa {maxDiscount} cho hoá đơn {minValue}',
  },
  invalidTitle: {
    id: `${scope}.invalidTitle`,
    defaultMessage: 'Rất tiếc, bạn chưa có voucher phù hợp.',
  },
  invalidDescription: {
    id: `${scope}.invalidDescription`,
    defaultMessage: 'Voucher bạn đã chọn không còn khả dụng, vui lòng xem lại giỏ hàng và kiểm tra voucher',
  },
  invalidAction: {
    id: `${scope}.invalidAction`,
    defaultMessage: 'Xem lại giỏ hàng',
  },
  invalidInput: {
    id: `${scope}.invalidInput`,
    defaultMessage: 'Rất tiếc không tìm thấy mã voucher này, hãy thử kiểm tra lại bạn nhé!',
  },
  notSatisfiedInput: {
    id: `${scope}.notSatisfiedInput`,
    defaultMessage: 'Mã giảm giá {code} chỉ sử dụng cho đơn hàng có tổng trị giá trên {total}',
  },
  notEligible: {
    id: `${scope}.notEligible`,
    defaultMessage: 'Chưa thoả điều kiện',
  },
});
